module.exports = InternalShared('InternalShared/Events/GetControlOptions');